import React from 'react';
import ArrowNavigationButton from '@monorepo/shared/src/components/activities/ArrowNavigationButton';
import ProgressProvider from '@monorepo/shared/src/providers/ProgressProvider';
import useGame from '@monorepo/shared/src/hooks/use-game';
import NavigationControl from '@monorepo/shared/src/components/modules/Paging/components/NavigationControl';
import ActivityHeaderLayout from '@monorepo/shared/src/components/activities/ActivityHeaderLayout';
import ActivityHeader from '@monorepo/shared/src/components/activities/ActivityHeader';
import SoundOutWordsContainer from './components/SoundOutWordsContainer';
import usePageViewAutoSwitch from '@monorepo/shared/src/hooks/use-page-view-auto-switch';
import makeStyles from '@mui/styles/makeStyles';
import { useWindowSize } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-window-size';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

type SoundOutWordsActivityProps = {
  backRoute?: string;
};

const SoundOutWords: React.FC<SoundOutWordsActivityProps> = ({ backRoute }) => {
  const { height: windowHeight } = useWindowSize();
  const classes = useStyles({ windowHeight });
  const [, { handleTurnActivityPage, handleCurrentPageCompletion }] = useGame();
  const omitRoutes = useTrialUserOmitRoutes();
  usePageViewAutoSwitch();

  return (
    <ProgressProvider handlePageCompletion={handleCurrentPageCompletion}>
      <ActivityHeaderLayout
        title={'Press the words to sound them out'}
        hasTogglePageView={true}
        backRoute={backRoute}
        Header={ActivityHeader}
        omitRoutes={omitRoutes}
      />
      <NavigationControl
        ArrowNavigationButton={ArrowNavigationButton}
        handleContinue={handleTurnActivityPage}
      />
      <div className={classes.wrapper}>
        <SoundOutWordsContainer />
      </div>
    </ProgressProvider>
  );
};
export default SoundOutWords;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: ({ windowHeight }: any) =>
      theme.typography.pxToRem(windowHeight - theme.constants.app.footerOffset),
    width: 'min(80vw, 1200px)',
    margin: '0 auto',
    padding: `${theme.typography.pxToRem(32)} 0`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
